export const RunStatus = {
    QUEUED: 'QUEUED',
    RUNNING: 'RUNNING',
    DONE: 'DONE',
    FAILED: 'FAILED',
    CANCELLED: 'CANCELLED',
};
/** Значення в порядку оголошення в схемі. */
export const RUN_STATUS_VALUES = ['QUEUED', 'RUNNING', 'DONE', 'FAILED', 'CANCELLED'];
export const RUN_STATUS_LABELS = {
    QUEUED: 'У черзі',
    RUNNING: 'Виконується',
    DONE: 'Завершено',
    FAILED: 'Помилка',
    CANCELLED: 'Скасовано',
};
export const RUN_STATUS_TONES = {
    QUEUED: 'neutral',
    RUNNING: 'info',
    DONE: 'success',
    FAILED: 'danger',
    CANCELLED: 'neutral',
};
//# sourceMappingURL=run-status.js.map